import { render, staticRenderFns } from "./TeamAudiList.vue?vue&type=template&id=f64764b8&scoped=true"
import script from "./TeamAudiList.vue?vue&type=script&lang=js"
export * from "./TeamAudiList.vue?vue&type=script&lang=js"
import style0 from "./TeamAudiList.vue?vue&type=style&index=0&id=f64764b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64764b8",
  null
  
)

export default component.exports